exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-334d9fbf] .el-card__body{height:100%}[data-v-334d9fbf] .el-icon-arrow-right{display:none}[data-v-334d9fbf] .el-badge__content{top:10px}", ""]);

// exports
